import type { ReactNode, SVGProps } from "react";

type ProgramIconProps = SVGProps<SVGSVGElement>;

export const InsiderKey40 = ({
  style,
  ...props
}: ProgramIconProps): ReactNode => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="40"
    style={{
      color: "var(--slate-color-program-icon-insider, #36676a)",
      ...style,
    }}
    viewBox="0 0 40 40"
    width="40"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M10.962 12.5c-3.976 0-7.212 3.239-7.212 7.25S6.986 27 10.962 27s7.212-3.239 7.212-7.25-3.235-7.25-7.212-7.25M.25 19.75C.25 13.82 5.04 9 10.962 9c4.945 0 9.1 3.36 10.337 7.92H40v3.5H21.654c-.345 5.619-4.993 10.08-10.692 10.08C5.04 30.5.25 25.68.25 19.75m39.724 5.633h-8.137v-3.5h8.137z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export const InsiderLogoLargeDefault = ({
  style,
  ...props
}: ProgramIconProps): ReactNode => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="26"
    style={{
      color: "var(--slate-color-program-text-insider, #154548)",
      ...style,
    }}
    viewBox="0 0 94 26"
    width="94"
    {...props}
  >
    <path
      d="M19.267 15.37h4.983m-12.226-3.62H24.25m-12.176.75c0 3.038-2.423 5.5-5.412 5.5-2.99 0-5.412-2.462-5.412-5.5S3.673 7 6.662 7s5.411 2.462 5.411 5.5Z"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    <path
      d="M33.798 19V6.13h2.412V19zm5.417 0V9.586h2.178v1.494c.45-.918 1.495-1.692 3.042-1.692 1.89 0 3.222 1.098 3.222 3.69V19H45.48v-5.724c0-1.422-.576-2.07-1.872-2.07-1.224 0-2.214.756-2.214 2.25V19zm14.324.18c-2.43 0-3.852-1.116-3.942-3.114h2.052c.108.954.594 1.512 1.872 1.512 1.17 0 1.692-.414 1.692-1.206 0-.774-.63-1.062-2.016-1.296-2.484-.396-3.402-1.098-3.402-2.862 0-1.89 1.764-2.826 3.528-2.826 1.926 0 3.456.72 3.69 2.844h-2.016c-.18-.864-.666-1.26-1.674-1.26-.936 0-1.494.45-1.494 1.116 0 .684.45.954 1.944 1.206 2.214.342 3.528.882 3.528 2.88 0 1.908-1.35 3.006-3.762 3.006m6.938-11.142c-.72 0-1.296-.54-1.296-1.242 0-.72.576-1.26 1.296-1.26s1.296.54 1.296 1.26c0 .702-.576 1.242-1.296 1.242M59.415 19V9.586h2.178V19zm8.511.18c-2.358 0-4.14-1.674-4.14-4.734v-.144c0-3.006 1.782-4.914 4.23-4.914 1.53 0 2.484.702 3.006 1.638V5.23H73.2V19h-2.178v-1.584c-.504.936-1.71 1.764-3.096 1.764m.54-1.728c1.512 0 2.628-1.008 2.628-3.114v-.144c0-2.07-.954-3.096-2.538-3.096-1.602 0-2.538 1.116-2.538 3.15v.144c0 2.07 1.044 3.06 2.448 3.06m11.613 1.728c-2.772 0-4.77-1.818-4.77-4.788v-.144c0-2.916 1.998-4.86 4.68-4.86 2.34 0 4.446 1.386 4.446 4.752v.63H77.54c.072 1.782.972 2.79 2.592 2.79 1.314 0 1.998-.522 2.16-1.44h2.106c-.306 1.98-1.908 3.06-4.32 3.06m-2.502-5.868h4.698c-.108-1.62-.936-2.34-2.286-2.34-1.314 0-2.196.882-2.412 2.34M86.53 19V9.586h2.178v1.764c.594-1.188 1.476-1.89 3.06-1.908v2.034c-1.908.018-3.06.63-3.06 2.628V19z"
      fill="currentColor"
    />
  </svg>
);

export const FairePaySquare = (props: ProgramIconProps): ReactNode => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="32"
    viewBox="0 0 32 32"
    width="32"
    {...props}
  >
    <rect fill="#333333" height="32" rx="2.66667" width="32" />
    <path
      d="M12.2391 22.7539V9H20.7608V11.039H14.7976V15.1364H19.4912V17.1177H14.7976V22.7539H12.2391Z"
      fill="white"
    />
  </svg>
);

export const ShopifyColored = (props: ProgramIconProps): ReactNode => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    {...props}
  >
    <path
      d="M19.938 4.623a.225.225 0 0 0-.213-.193c-.096 0-1.798-.039-1.798-.039S16.496 3 16.36 2.863c-.135-.135-.425-.096-.522-.058 0 0-.27.078-.715.213a5.7 5.7 0 0 0-.348-.85c-.503-.968-1.257-1.49-2.147-1.49-.058 0-.116 0-.193.02-.02-.04-.058-.059-.078-.097-.386-.426-.889-.619-1.489-.6-1.16.039-2.32.87-3.248 2.36-.658 1.044-1.16 2.359-1.315 3.384-1.335.406-2.263.696-2.282.715-.677.213-.696.232-.774.87-.058.484-1.837 14.117-1.837 14.117L16.186 24l6.401-1.586c-.019-.02-2.63-17.675-2.649-17.79m-5.55-1.373c-.348.097-.735.232-1.14.348 0-.58-.078-1.411-.349-2.108.87.174 1.296 1.16 1.489 1.76m-1.934.6c-.773.232-1.624.502-2.475.754.232-.91.696-1.818 1.238-2.417.212-.213.502-.465.831-.62.348.678.426 1.625.406 2.283M10.888.775q.406 0 .696.174c-.31.174-.619.406-.909.715-.735.793-1.296 2.03-1.528 3.21l-2.03.62c.406-1.857 1.972-4.661 3.77-4.72"
      fill="#95BF47"
    />
    <path
      d="M19.725 4.43c-.096 0-1.798-.039-1.798-.039S16.496 3 16.36 2.863a.37.37 0 0 0-.192-.096V23.98l6.4-1.586-2.63-17.791a.23.23 0 0 0-.213-.174"
      fill="#5E8E3E"
    />
    <path
      d="m12.61 7.717-.735 2.785s-.832-.387-1.818-.31c-1.45.097-1.45 1.006-1.45 1.238.077 1.238 3.345 1.508 3.538 4.429.136 2.3-1.218 3.867-3.171 3.983-2.36.155-3.655-1.237-3.655-1.237l.503-2.128s1.295.987 2.34.91c.676-.04.928-.6.909-.987-.097-1.624-2.766-1.528-2.94-4.196-.135-2.244 1.334-4.525 4.583-4.719 1.257-.097 1.896.232 1.896.232"
      fill="#FFF"
    />
  </svg>
);

export const Square = ({ style, ...props }: ProgramIconProps): ReactNode => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="24"
    style={{ color: "var(--slate-color-icon-primary, #333333)", ...style }}
    viewBox="0 0 24 24"
    width="24"
    {...props}
  >
    <path
      d="M19.99 0H4.01A4.01 4.01 0 0 0 0 4.01v15.98A4.01 4.01 0 0 0 4.01 24h15.98A4.01 4.01 0 0 0 24 19.99V4.01A4.01 4.01 0 0 0 19.99 0m-.353 18.37c0 .7-.567 1.267-1.267 1.267H5.63c-.7 0-1.267-.567-1.267-1.267V5.63c0-.7.567-1.267 1.267-1.267h12.74c.7 0 1.267.567 1.267 1.267zM9.454 15.258a.726.726 0 0 1-.726-.73V9.443c0-.403.323-.731.726-.731h5.094c.4 0 .726.326.726.731v5.084a.73.73 0 0 1-.726.73H9.454z"
      fill="currentColor"
    />
  </svg>
);

export const Clover = ({ style, ...props }: ProgramIconProps): ReactNode => (
  <svg
    aria-hidden="true"
    fill="none"
    focusable="false"
    height="24"
    style={{ color: "#228800", ...style }}
    viewBox="0 0 24 24"
    width="24"
    {...props}
  >
    <g fill="currentColor">
      <path d="M11.214 5.607A5.61 5.61 0 0 0 5.606 0 5.605 5.605 0 0 0 0 5.604a5.61 5.61 0 0 0 5.607 5.61h5.607zM12.786 5.607A5.61 5.61 0 0 1 18.394 0 5.605 5.605 0 0 1 24 5.604a5.61 5.61 0 0 1-5.607 5.61h-5.607zM12.786 18.393a5.607 5.607 0 1 0 5.607-5.607h-5.607zM11.214 18.393a5.607 5.607 0 1 1-5.607-5.607h5.607zM5.605 22.42a4.034 4.034 0 0 0 4.036-4.024V14.36H5.61a4.045 4.045 0 0 0-4.038 4.035 4.033 4.033 0 0 0 4.032 4.024" />
    </g>
  </svg>
);
